import React from 'react';
export function PrivacyPage() {
  return <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8" data-id="element-502">
      <div className="max-w-3xl mx-auto" data-id="element-503">
        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-504">
          Política de Privacidad y Protección de Datos
        </h1>

        <div className="space-y-6 text-base text-gray-600 leading-relaxed" data-id="element-505">
          <section data-id="element-506">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-507">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-508">
              En TicketMaestro valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-509">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-510">
              2. RESPONSABLE DEL TRATAMIENTO
            </h3>
            <ul className="space-y-2" data-id="element-511">
              <li data-id="element-512">
                <strong data-id="element-513">Nombre de la entidad:</strong> TicketMaestro SAS
              </li>
              <li data-id="element-514">
                <strong data-id="element-515">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-516">
                <strong data-id="element-517">Correo electrónico de contacto:</strong>{' '}
                <span className="text-emerald-600" data-id="element-518">contacto@benefica.net</span>
              </li>
            </ul>
          </section>

          <section data-id="element-519">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-520">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h3>
            <p className="mb-3" data-id="element-521">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-522">
              <li data-id="element-523">Nombres y apellidos</li>
              <li data-id="element-524">Número de Cédula</li>
              <li data-id="element-525">Correo electrónico</li>
              <li data-id="element-526">Número de teléfono</li>
              <li data-id="element-527">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-528">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </section>

          <section data-id="element-529">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-530">
              4. FINALIDAD DEL TRATAMIENTO
            </h3>
            <p className="mb-3" data-id="element-531">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-532">
              <li data-id="element-533">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-534">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-535">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-536">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-537">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-538">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-539">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-540">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h3>
            <p className="mb-3" data-id="element-541">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-542">
              <li data-id="element-543">Tu consentimiento expreso</li>
              <li data-id="element-544">
                El interés legítimo de Benefika para cumplir su misión
                institucional
              </li>
              <li data-id="element-545">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-546">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-547">
              6. DESTINATARIOS DE LOS DATOS
            </h3>
            <p className="mb-3" data-id="element-548">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-549">
              <li data-id="element-550">Tengamos tu consentimiento previo</li>
              <li data-id="element-551">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-552">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-553">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-554">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h3>
            <p className="mb-3" data-id="element-555">Tienes derecho a:</p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-556">
              <li data-id="element-557">Acceder a tus datos personales</li>
              <li data-id="element-558">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-559">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-560">Oponerte al tratamiento</li>
              <li data-id="element-561">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-562">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-4" data-id="element-563">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <span className="font-medium text-emerald-600" data-id="element-564">
                protecciondatos@benefica.net
              </span>
            </p>
          </section>

          <section data-id="element-565">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-566">
              8. USO DE COOKIES
            </h3>
            <p data-id="element-567">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-568">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-569">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h3>
            <p data-id="element-570">
              Benefika aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-571">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-572">
              10. CONSERVACIÓN DE LOS DATOS
            </h3>
            <p data-id="element-573">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-574">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-575">
              11. CAMBIOS A ESTA POLÍTICA
            </h3>
            <p data-id="element-576">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-577">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-578">
              12. AUTORIDAD DE CONTROL
            </h3>
            <p data-id="element-579">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-580">
            <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-581">
              13. VIGENCIA
            </h3>
            <p data-id="element-582">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 21 de noviembre de 2025 y permanecerá vigente hasta
              que exista una nueva versión que la reemplace.
            </p>
          </section>

          <div className="pt-8 mt-8 border-t border-gray-200 text-sm text-gray-500" data-id="element-583">
            Última actualización: 21 de noviembre de 2025
          </div>
        </div>
      </div>
    </div>;
}